// 节流
function throttle(fn, wait) {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        if (!timer) {
            timer = setTimeout(function () {
                fn.apply(context, args);
                timer = null;
            }, wait);
        }
    };
}
// 获取滚动距离
function getScrollTop(ele) {
    if (ele === document.body) {
        return document.body.scrollTop || document.documentElement.scrollTop
    } else {
        return ele.scrollTop;
    }
}
// 下拉加载
export function getMore(ele, callback, bottomDistence = 20) {
    if (!ele) {
        return;
    }
    const scrollbarDom = ele;
    if (scrollbarDom.onscroll) {
        return
    }
    const updatePosition = () => {
        const scrollTop = getScrollTop(ele);
        const clientHeight = scrollbarDom.clientHeight;
        const scrollHeight = scrollbarDom.scrollHeight;
        if (scrollTop + clientHeight >= scrollHeight - bottomDistence) {
            callback();
        }
    };
    const throttled = throttle(updatePosition, 500);
    scrollbarDom.onscroll = throttled;
}